import React from "react";

export default function InterviewHome({ sessionId, onStartInterview }) {
  return (
    <div className="text-center h-full flex flex-col items-center justify-center">
      <h1 className="text-4xl font-bold mb-8 text-blue-600 dark:text-blue-400">
        AI Interview Practice
      </h1>
      <button
        onClick={onStartInterview}
        disabled={!sessionId}
        className="bg-indigo-600 text-white px-8 py-4 rounded-lg text-lg hover:bg-indigo-700 disabled:opacity-50 disabled:cursor-not-allowed"
      >
        Start Interview
      </button>
      {!sessionId && (
        <p className="mt-4 text-sm text-red-500">
          Session ID is missing. Cannot start interview.
        </p>
      )}
    </div>
  );
}
